import type { IconData } from '@stacksjs/iconify-core'

export const creditCard: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 72H40a24.03 24.03 0 0 0-24 24v320a24.03 24.03 0 0 0 24 24h432a24.03 24.03 0 0 0 24-24V96a24.03 24.03 0 0 0-24-24m-8 32v64H48v-64ZM48 408V232h416v176Z\"/><path fill=\"currentColor\" d=\"M88 312h64v32H88zm96 0h64v32h-64z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default creditCard
